import { useCheckPermission } from "../../hooks/useCheckPermission";

export function useNavItems({ tenancy, t }) { 
  const hasReportsPermission = useCheckPermission("REVIEW_REPORTS");
  const hasAuditTrailPermission = useCheckPermission("REVIEW_AUDIT");
  const hasLogsPermission = useCheckPermission("LOGS");
  const hasMonitoringPermission = useCheckPermission(
    tenancy === "SINGLE" ? "REVIEW_MONITORING" : "SEARCH_REVIEW_MONITORING",
  );
  const hasManualSearchPermission = useCheckPermission(
    tenancy === "SINGLE" ? "MANUAL_SEARCH" : "MANUAL_SEARCH_MULTI",
  );

  const navArr = [
    { text: t("sidebar.home"), path: "/", id: 1 },
    { text: t("sidebar.rules"), path: "/rules", id: 2 },
  ];

  if (hasMonitoringPermission) {
    navArr.push({
      text: t("sidebar.monitoringQueue"),
      path: "/monitoring",
      id: 3,
    });
  }

  if (hasReportsPermission) {
    navArr.push({
      text: t("sidebar.reports"),
      path: null,
      id: 4,
      items: [
        { text: t("sidebar.singleReports"), path: "/reports-single", id: 5 },
        {
          text: t("sidebar.multipleReports"),
          path: "/reports-multiple",
          id: 6,
        },
        {
          text: t("sidebar.dailyOverlimitReports"),
          path: "/reports-daily-overlimit",
          id: 7,
        },
        {
          text: t("sidebar.forMonitoringReports"),
          path: "/reports-for-monitoring",
          id: 8,
        },
        { text: t("sidebar.customReports"), path: "/reports-custom", id: 9 },
      ],
    });
  }

  if (hasAuditTrailPermission) {
    navArr.push({
      text: t("sidebar.auditTrail"),
      path: "/audit-trail",
      id: 10,
    });
  }

  if (hasLogsPermission) {
    navArr.push({
      text: t("sidebar.activityLog"),
      path: "/activity-log",
      id: 11,
    });
  }

  if (hasManualSearchPermission) {
    navArr.push({
      text: t("sidebar.manualSearch"),
      path: "/manual-search",
      id: 12,
    });
    navArr.push({
      text: t("sidebar.advancedSearchMenu"),
      path: null,
      id: 13,
      items: [
        { text: t("sidebar.advancedSearch"), path: "/advanced-search", id: 14 },
        {
          text: t("sidebar.advancedSearchHistory"),
          path: "/advanced-search-history",
          id: 15,
        },
      ],
    });
  }

  navArr.push({ text: t("sidebar.settings"), path: "/settings", id: 16 });

  return navArr;
}
